export default __webpack_public_path__ + "static/app-features-4-cf60de682b4b679d1a9398ed5275494c.png";